var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPencilEdit = function SvgPencilEdit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.417 12.75h5.333m-12-.003 1.818.003c.26 0 .39 0 .511-.029.109-.026.212-.069.307-.127.107-.066.2-.158.383-.343l8.649-8.686c.353-.355.44-.904.172-1.338A4.214 4.214 0 0 0 11.3.917a1.046 1.046 0 0 0-1.31.142L1.29 9.799c-.177.177-.266.266-.33.37-.057.091-.1.191-.126.296-.03.118-.034.244-.04.495L.75 12.747Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPencilEdit);
export default ForwardRef;